// Ubicación completa que se muestra sobre el mapa de "Ubicación" de la ficha en la web. Misma
// regla que `buildFullAddress` de propi-web-nextjs (src/helpers/propertyLocation.ts): si se
// cambia una, se cambia la otra. No hay campo nuevo en el backend: la web la arma con la
// dirección y los nombres de la ubicación que el detalle ya trae. La calle NO viaja en el
// detalle público, así que tampoco entra aquí.

export interface LocationRelatives {
  nb_name?: string;
  tower_name?: string;
  residential_name?: string;
  city_name?: string;
  state_name?: string;
  country_name?: string;
}

// Sin tildes ni mayúsculas, para comparar "San Salvador" con "san salvador".
const normalize = (text: string): string =>
  text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();

export const buildFullAddress = (
  address?: string | null,
  relatives?: LocationRelatives | null,
): string => {
  const parts = [
    address,
    // Torre (solo si la ubicación elegida es una torre), luego colonia o residencial: el residencial es más específico, la colonia es el respaldo.
    relatives?.tower_name,
    relatives?.residential_name || relatives?.nb_name,
    relatives?.city_name,
    relatives?.state_name,
    relatives?.country_name,
  ]
    // Sin espacios ni puntuación final: "Calle X." no debe dejar "X., Colonia".
    .map((part) => (part ?? '').trim().replace(/[.,;\s]+$/, ''))
    .filter(Boolean);

  const seen = new Set<string>();
  return parts
    .filter((part) => {
      const key = normalize(part);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .join(', ');
};
